module.exports = __webpack_public_path__ + "img/F5-4A.4de9f3f2.png";